import { currentLanguage } from '../../i18n';

export const JAVA_BACKEND_API_URL   = process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api/v1`
    : "https://gw.sakagrup.com:8443/api/v1";
export const NODE_BACKEND_API_URL   = "https://gw.sakagrup.com";
export const NODE_BACKEND_API_PORT  = "";
export const JAVA_BACKEND_USER_PASS = 'fds_mobile:Rk3%${Vx]x';
export const EXTERNAL_IMAGE_PATH    = 'https://fds.sakagrup.com/';

// /public/files/... uçları /api/v1'in DIŞINDA servis edilir (bkz. PublicFileController).
// Backend göreli bir dosya yolu döndürdüğünde (firmaLogoUrl, firma fotoğrafları)
// gösterilebilir src'yi üretmek için bu köken kullanılır.
export const JAVA_BACKEND_ORIGIN = JAVA_BACKEND_API_URL.replace(/\/api\/v1$/, '');

// Auth header oluşturucu - tüm servislerde kullan
// #332 (2026-10-12): plus Accept-Language from the UI's TR/EN switch, so the backend answers names
// from the database in the language on screen (backend #330) instead of the browser's own language.
export const getAuthHeader = () => {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    return {
        'Authorization': 'Basic ' + btoa(JAVA_BACKEND_USER_PASS),
        'X-user-Id': userId || '',
        'X-token': token || '',
        'Accept-Language': currentLanguage(),
    };
};

// Public endpoint header — sadece app-level Basic auth, kullanıcı token/id yok.
// Giriş yapmamış dış kullanıcılar (firma yetkilileri) için kullan.
// WAS (until #332): export const getPublicHeader = () => ({ 'Authorization': 'Basic ' + btoa(JAVA_BACKEND_USER_PASS), });
export const getPublicHeader = () => ({
    'Authorization': 'Basic ' + btoa(JAVA_BACKEND_USER_PASS),
    'Accept-Language': currentLanguage(),
});
 export const FORMENDPOINTS= {
     savesahaform : `${JAVA_BACKEND_API_URL}/form/sahaform/checkOrSave`,
     sahaformlist : `${JAVA_BACKEND_API_URL}/sahaforms`,
     sahaformdetail : `${JAVA_BACKEND_API_URL}/sahaform`,
     getContentValues : `${JAVA_BACKEND_API_URL}/form/getContentValues`,
     saveformcContent : `${JAVA_BACKEND_API_URL}/form/saveFormContent`,
     getFormAnswers : `${JAVA_BACKEND_API_URL}/form/getFormAnswers`,
     getFormPhotos : `${JAVA_BACKEND_API_URL}/form/sahaform`,
     uploadPhoto : `${JAVA_BACKEND_API_URL}/form/sahaform`
}